<template>
  <div class="log-out-button">
    <button
      :class="buttonClass"
      :disabled="working"
      aria-label="Log out"
      class="log-out-button__btn btn-rounded"
      @click="logout">
      <slot>
        Log out
      </slot>
      <template v-if="working">
        <span class="visually-hidden">
          Loading...
        </span>
        <font-awesome-icon class="log-out-button__working"
                           icon="spinner"
                           spin></font-awesome-icon>
      </template>
    </button>
  </div>
</template>

<script>
import { logout } from "~/Scripts/resources/webAccountResource";

export default {
  name: "LogoutButton",
  props: {
    buttonClass: {
      type: String,
      default: "btn btn-accent-6"
    },
    redirectUrl: {
      type: String,
      default: "/"
    }
  },

  data () {
    return {
      working: false
    };
  },

  methods: {
    logout () {
      this.working = true;
      logout()
        .then( () => {
          window.location = this.redirectUrl;
        } )
        .catch( () => {
          this.working = false;
        } );
    }
  }
};
</script>

<style lang="less" scoped>
.log-out-button__btn {
  min-width: 110px;
}

.log-out-button__working {
  margin-left: 5px;
}
</style>
